/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, inject } from '@angular/core';
import { CDS_POPUP_DATA, MatDialogRef } from '../cd-popup.service';
import { CdPopupComponent } from '../cd-popup/cd-popup.component';
import { CdsPopupModule } from '@cds/ng-web-components/popup';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-cd-popup-continue',
  templateUrl: './cd-popup-continue.component.html',
  styleUrls: ['./cd-popup-continue.component.scss'],
  imports: [CdPopupComponent, CdsPopupModule, CdsButtonModule, CdsLanguageModule],
})
export class CdPopupContinueComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<CdPopupContinueComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    message: string;
    subMessage: string;
    continue: string;
    params: any;
  }>(CDS_POPUP_DATA);

  ngOnInit() {}

  cancle() {
    this.dialogRef.close({ continue: false });
  }

  continue() {
    this.dialogRef.close({ continue: true });
  }
}
